/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaChevronDown } from 'react-icons/fa';

// ---------------------------------------------------------------------------
// Accordion do módulo Recrutamento (mock .acc, redesign 2026-07-14): card com
// head clicável (título + meta + caret rotativo) e corpo colapsável. Head é um
// <button> real (foco/teclado). Vive no módulo até outro precisar (H.4 —
// promover pra styles/ui/ ao reusar fora daqui, não copiar).
// ---------------------------------------------------------------------------

const border = ({ theme }) => theme?.colors?.border ?? 'rgba(0,0,0,0.10)';
const muted = ({ theme }) => theme?.colors?.textMuted ?? '#6b7280';
const ink = ({ theme }) => theme?.colors?.textPrimary ?? '#1f1f18';

const Shell = styled.div`
   background: #fff;
   border: 1px solid ${border};
   border-radius: 14px;
   margin-bottom: 16px;
`;

const Head = styled.button`
   width: 100%;
   display: flex;
   align-items: center;
   gap: 12px;
   padding: 16px 18px;
   background: transparent;
   border: 0;
   cursor: pointer;
   text-align: left;
   font-family: inherit;

   h2 {
      font-size: 1rem;
      font-weight: 800;
      margin: 0;
      color: ${ink};
   }
   .acc-meta {
      font-size: 12px;
      color: ${muted};
   }
   .acc-caret {
      margin-left: auto;
      color: ${muted};
      transition: transform 160ms ease;
      transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
      flex: 0 0 auto;
   }

   &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px rgba(64, 152, 239, 0.3);
      border-radius: 14px;
   }
`;

const Body = styled.div`
   padding: 0 18px 18px;
   border-top: 1px solid ${border};
`;

export default function Accordion({
   title,
   meta = null,
   defaultOpen = false,
   children,
}) {
   const [open, setOpen] = useState(defaultOpen);

   return (
      <Shell>
         <Head
            type="button"
            $open={open}
            onClick={() => setOpen((prev) => !prev)}
            aria-expanded={open}
         >
            <h2>{title}</h2>
            {meta && <span className="acc-meta">{meta}</span>}
            <FaChevronDown size={15} className="acc-caret" />
         </Head>
         {open && <Body>{children}</Body>}
      </Shell>
   );
}

Accordion.propTypes = {
   title: PropTypes.node.isRequired,
   meta: PropTypes.node,
   defaultOpen: PropTypes.bool,
   children: PropTypes.node,
};
